import React, {useEffect, useState} from "react";
import apiRequests from "../../Component/axios/config/config";
import {FaEdit} from "react-icons/fa";
import toast from "react-hot-toast";

export default function Setting() {

    const [loading, setLoading] = useState(true);

    const [loadingBtn, setLoadingBtn] = useState(false);

    const [items, setItems] = React.useState({
        firstName: "",
        lastName: "",
        userName: "",
        password: ""
    });

    function getApi() {

        setLoading(true);
        apiRequests.get('/api/admin/v1/get-my-profile')
            .then(res => {
                const data = res.data.data;
                setItems({
                    firstName: data.firstName,
                    lastName: data.lastName,
                    userName: data.userName,
                    password: "",
                });
            })
            .catch(err => {
            })
            .finally(() => setLoading(false));

    }

    useEffect(() => {
        getApi()
    }, []);

    function handleEditSubmit() {

        setLoadingBtn(true);
        apiRequests.put('/api/admin/v1/edit-my-profile', items)
        .then(res => {
            toast.success("اطلاعات با موفقیت ویرایش شد")
            window.location.reload();
        })
        .catch(err => {})
        .finally(() => setLoadingBtn(false));

    }

    return (
        <div>
            <div className="px-6 text-3xl text-right">تنظیمات ادمین</div>

            <div className="flex flex-col gap-1 mt-8 px-12 ">

                {loading ?
                    "در حال دریافت اطلاعات ..."
                    :

                    <>
                        <div className="flex flex-col gap-1 w-[50%]">
                            <span>نام کاربری </span>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-md p-2 mb-4"
                                value={items.userName}
                                onChange={(e) => setItems({...items, userName: e.target.value})}
                                placeholder="نام کاربری جدید را وارد کنید"
                            />
                        </div>

                        <div className="flex flex-col  gap-1 w-[50%]">
                            <span>نام </span>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-md p-2 mb-4"
                                value={items.firstName}
                                onChange={(e) => setItems({...items, firstName: e.target.value})}
                                placeholder="نام جدید را وارد کنید"
                            />
                        </div>

                        <div className="flex flex-col  gap-1 w-[50%]">
                            <span>نام خانوادگی </span>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-md p-2 mb-4"
                                value={items.lastName}
                                onChange={(e) => setItems({...items, lastName: e.target.value})}
                                placeholder="نام خانوادگی جدید را وارد کنید"
                            />
                        </div>

                        <div className="flex flex-col  gap-1 w-[50%]">
                            <span>رمز جدید </span>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-md p-2 mb-4"
                                value={items.password}
                                onChange={(e) => setItems({...items, password: e.target.value})}
                                placeholder="رمز عبور جدید را وارد کنید"
                            />
                        </div>

                        <button
                            className="bg-BlueColor-shade7 flex gap-2 items-center w-fit text-white px-4 py-2 rounded hover:bg-green-600"
                            onClick={handleEditSubmit}
                        >
                            {loadingBtn ?

                                "در حال تایید ..."
                                :
                                <>
                                    <FaEdit className="mb-1"/>
                                    اعمال ویرایش
                                </>
                            }

                        </button>
                    </>
                }


            </div>


        </div>
    )
}